import React from 'react';
import PropTypes from 'prop-types';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';

const sx = {
  borderBottom: '1px solid rgba(0, 0, 0, 0.12)',
  padding: '24px'
};

const LabeledStepper = ({ step = 1, steps = [] }) => {
  return (
    <Stepper sx={sx} activeStep={step - 1}>
      {steps.map((item, index) => (
        <Step key={`step_${index}`}>
          <StepLabel>{item}</StepLabel>
        </Step>
      ))}
    </Stepper>
  );
};

export default LabeledStepper;

LabeledStepper.propTypes = {
  step: PropTypes.number,
  steps: PropTypes.array
};
